

import { ApiEndpoints } from "@shared/api/api-endpoints";
import { communicationApiClient} from "@shared/api/clients/apiClientFactory";
import { DEFAULT_PAGE_NUMBER, PAGE_SIZE } from "@shared/utils/constants";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";



export const templatesApi = {

  createTemplate: async (payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl("communication", "communication-templates");
    const response = await communicationApiClient.post(url, payload);
    return response.data;
  },
  testSendTemplate: async (payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl("communication", "communication-templates/test-send");
    const response = await communicationApiClient.post(url, payload);
    return response.data;
  },
    updateTemplate: async (payload: any,templateId: any): Promise<any> => {
   const url = ApiEndpoints.createUrl(
    "communication",
    `communication-templates/${templateId}`)
    const response = await communicationApiClient.put(url, payload);
    return response.data;
  },


 updateTemplateStatus: async (payload: any,templateId: any): Promise<any> => {
   const url = ApiEndpoints.createUrl(
    "communication",
    `communication-templates/${templateId}`)
    const response = await communicationApiClient.patch(url, payload);
    return response.data;
  },


      cloneTemplate: async (payload: any,templateId: any): Promise<any> => {
   const url = ApiEndpoints.createUrl(
    "communication",
    `communication-templates/${templateId}/duplicate`)
    const response = await communicationApiClient.post(url, payload);
    return response.data;
  },
  
    bulkAddTemplate: async (payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl("communication", "bulk-template-add");
    const response = await communicationApiClient.post(url, payload);
    return response.data;
  },
getTemplateList: async (params?: { 
  page?:any;
  search?: string;
  channel?: string;
  audienceType?: string;
  status?: string;
}): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "communication",
    "communication-templates",
    (qs) => {
      qs.push("remote_utility_id", getRemoteUtilityId());
      qs.push("page", params?.page?.toString() || DEFAULT_PAGE_NUMBER);
      qs.push("limit", PAGE_SIZE);

      if (params?.search) {
        qs.push("search_data", params.search);
      }
      
      if (params?.channel) {
        qs.push("channel", params.channel);
      }
      
      if (params?.audienceType) {
        qs.push("audience_type", params.audienceType);
      }
      
      if (params?.status) {
        qs.push("status", params.status);
      }
    }
  );

  const response = await communicationApiClient.get(url);
  return response.data;
},
getDefaultTemplate: async (): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "communication",
    "communication-templates",
    (qs) => {
      qs.push("remote_utility_id", getRemoteUtilityId());
      qs.push("page", DEFAULT_PAGE_NUMBER);
      qs.push("limit", "15");
      qs.push("created_user_remote_name","System");
    }
  );

  const response = await communicationApiClient.get(url);
  return response.data;
},
getTemplateData : async (templateId: any) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "communication",
    `communication-templates/${templateId}`,
    (query) => {
      query.push("remote_utility_id",getRemoteUtilityId());
    }
  );
  const response = await communicationApiClient.get(url);
  return response.data.result ?? [];
},
getTemplateMetaData : async () => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "communication",
    "get-templates",
    (query) => {
      query.push("remote_utility_id",getRemoteUtilityId());
    }
  );
  const response = await communicationApiClient.get(url);
  return response.data.result ?? [];
},


getSegmentsData: async () => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "communication",
    "segments",
    (query) => {
      query.push("remote_utility_id",getRemoteUtilityId());
    }
  );
  const response = await communicationApiClient.get(url);
  return response.data ;
},

getSignatureData: async () => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "communication",
    "email-signatures",
    (query) => {
      query.push("remote_utility_id",getRemoteUtilityId());
    }
  );
  const response = await communicationApiClient.get(url);
  return response.data ;
},
getVersionHistory : async (templateId: any) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "communication",
    `communication-templates/version-history/${templateId}`,
    (query) => {
      query.push("remote_utility_id",getRemoteUtilityId());
    }
  );
  const response = await communicationApiClient.get(url);
  return response.data.result ?? [];
},

getTemplateWorkflow : async (templateId: any) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "communication",
    `communication-templates/${templateId}/workflows`,
    (query) => {
      query.push("remote_utility_id",getRemoteUtilityId());
    }
  );
  const response = await communicationApiClient.get(url);
  return response.data ?? [];
},
};


